export type UnderlyingHistorics = {
  histos: UnderlyingHistoric[];
};

export type UnderlyingHistoric = {
  underlyingCode: string;
  currency: string;
  histo: UnderlyingPoint[];
};

export type UnderlyingPoint = {
  date: number;
  close: number;
};

export type GraphData = number[][];

export enum GraphType {
  Mono,
  Multi,
}
